<template>
  <RevDialog :name :title="i18n(translations.title)">
    <template #body>
      <p class="body-1">{{ i18n(translations.description) }}</p>
    </template>

    <template #footer>
      <RevButton full-width="always" variant="primary" @click="$emit('accept')">
        {{ i18n(translations.acceptButtonText) }}
      </RevButton>
      <RevButton
        class="mt-12"
        full-width="always"
        variant="secondary"
        @click="$emit('decline')"
      >
        {{ i18n(translations.declineButtonText) }}
      </RevButton>
    </template>
  </RevDialog>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'

import translations from '../newConversation.translations'

defineProps<{ name: string }>()

defineEmits<{ accept: []; decline: [] }>()

const i18n = useI18n()
</script>
